<mat-form-field class="w-100" [subscriptSizing]="hideMatHint ? 'dynamic' : 'fixed'">
    <mat-label>{{ field.name }}</mat-label>

    <input
        [decimalInput]="field?.validators?.decimals"
        [allowNegative]="field?.validators?.min === undefined || field?.validators?.min < 0"
        [formControl]="fc"
        [name]="field.name"
        [placeholder]="field.name"
        appDecimalInput
        matInput
        type="text" />

    @if (fc.value && !fc.disabled) {
        <button (click)="fc.setValue(null)" matSuffix mat-icon-button>
            <mat-icon fontSet="fas" fontIcon="fa-x"></mat-icon>
        </button>
    }

    <mat-error [control]="fc"></mat-error>
</mat-form-field>
